module.exports = __webpack_public_path__ + "img/user_avatar_black.18e6104b.svg";